import type { AxiosResponse } from 'axios';
import api from '../axios';
import type { propsApiMarketIndexRate } from '../interfaces';

export function latestMarketIndexesRequest(): Promise<
  AxiosResponse<propsApiMarketIndexRate[]>
> {
  return api.get('/v1/market-indexes');
}
